import styled, { css } from 'styled-components';

export const OrderConfirmationWrapper = styled.div`
  display: flex;
  gap: 24px;
`;

export const LeftWrapper = styled.div<{ isMobile: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 24px;

  ${({ isMobile }) =>
    isMobile &&
    css`
      flex-direction: column;
      justify-content: center;
      height: 100%;
      margin-top: -44px;
      gap: 0;
    `}
`;

export const Title = styled.p<{ isMobile?: boolean }>`
  ${({ isMobile, theme }) => (isMobile ? theme.FONT.H5 : theme.FONT.H3)};
  margin-top: ${({ isMobile }) =>
    isMobile
      ? '-157px'
      : '-183px'}; // mobile에서는 header 차이만큼 더 이동해주어야 함
  padding-top: ${({ isMobile }) => (isMobile ? '157px' : '183px')};
  margin-bottom: 19px;
`;

export const StickyBox = styled.div`
  position: sticky;
  top: ${({ theme }) => `calc(${theme.HEIGHT.PC_HEADER} + 40px)`};
  width: 384px;
  height: fit-content;
  padding: 30px;
  border-radius: ${({ theme }) => theme.BORDER_RADIUS.LEVEL_02};
  background-color: ${({ theme }) => theme.COLOR.WHITE};
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07);
`;

export const SectionTitle = styled.p<{
  isMobile: boolean;
  noMargin?: boolean;
  fontSize?: string;
  fontWeight?: number;
}>`
  margin-bottom: ${({ noMargin }) => !noMargin && '20px'};
  ${({ isMobile, theme }) => (isMobile ? theme.FONT.H4 : theme.FONT.H5)};

  font-size: ${({ fontSize }) => fontSize && fontSize};
  font-weight: ${({ fontWeight }) => fontWeight && fontWeight};
`;

export const ListWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 2px;
  line-height: 27px;
`;

export const FlexColWrapper = styled.div<{ gap?: string }>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => gap};
`;

export const InfoTitle = styled.p`
  min-width: 110px;
  ${({ theme }) => theme.FONT.B1};
  font-weight: 600;
  line-height: 27px;
`;

export const InfoText = styled.p`
  width: fit-content;
  ${({ theme }) => theme.FONT.B1};
  word-break: keep-all;
`;

export const ListTitle = styled.p<{ isMobile: boolean }>`
  font-size: ${({ isMobile }) => (isMobile ? '17px' : '18px')};
  font-weight: 600;
  margin-top: 20px;
`;

export const ListSubTitle = styled.p<{ isMobile: boolean }>`
  font-size: 16px;
  font-weight: 600;
  margin-top: 12px;
`;

export const ListItem = styled.p<{ isMobile: boolean }>`
  font-size: 16px;
  font-weight: 400;
  line-height: 27px;
`;
